<template>
  <div class="form__field-holder"
       :class="{'form__field-holder_error': !!errors.has(newName)}"
       data-vv-value-path="model"
       :data-vv-as="label">
    <div class="form__field-box">
      <label class="form__label" v-if="showLabel && labelHtml" v-html="labelHtml"></label>
      <label class="form__label" v-else-if="showLabel">
        {{ label }}
      </label>
          <div :class="['form__input-item', IsExtraInfo ? 'form__extra-info' : '']" style="position: relative;">
            <input
              class="form__textfield"
              v-model="model"
              :type="type || `text`"
              :name="name"
              :disabled="disabled"
              :placeholder="placeholder"
             :min="min"
             :max="max"
             v-on="limitNumbersInput ? { input: () => limitInput(10) } : {}"
              @change="$emit('change', $event)"
              @blur="$emit('blur', $event)"
              :autocomplete="autocomplete"
              :aria-invalid="!!errors.has(newName)"
              :aria-describedby="errors.has(newName) ? (newName + '-error') : null"
            />
            <template v-if="type == 'password'">
              <i
                class="fa fa-eye-slash"
                style="right: 10px; cursor: pointer; position: absolute; top: 18px"
                @click="togglePassword"
                :title="locales && locales.common && locales.common.show_password"
            ></i>
            </template>
            <template>
              <div class="form__extra-info__content" v-if="IsExtraInfo">
                <slot name="extra-info"></slot>
              </div>
            </template>
          </div>
    </div>
    <div class="form__field-error" :id="newName + '-error'" v-if="errors.has(newName)">
      {{ errors.first(newName) }}
    </div>
  </div>
</template>

<script>
  import field from '../mixins/field'
  import { mapGetters } from "vuex";

  export default {
    data() {
      return {
        autocomplete: this.isPrefillDisabled ? 'off' : 'on'
      }
    },
    computed: {
      ...mapGetters(["locales"]),
    },
    mounted() {
      if (this.isPrefillDisabled) {
        this.disableAutoComplete();
      }
    },
    mixins: [field],
    methods: {
      limitInput(number) {
        if (this.model > number) {
          this.model = this.model - (this.model - number);
        }
      }
    },
    props: {
      limitNumbersInput: {
        default: false,
        type: Boolean
      },
      placeholder: {
        default: null,
        type: String
      },
      min: {
        default: '',
        type: String
      },
      max: {
        default: '',
        type: String
      },
      labelHtml: {
        default() {
          return ''
        },
        type: String
      },
      showLabel: {
        default: true,
        type: Boolean
      },
      isPrefillDisabled: {
        default: false,
        type: Boolean
      },
      IsExtraInfo: {
        default: false,
        type: Boolean
      }
    },
    methods: {
      disableAutoComplete() {
        let elements = document.querySelectorAll('[autocomplete="off"]');

        if (!elements) {
          return;
        }

        [...elements].forEach(element => {
          element.setAttribute('readonly', 'readonly');

          setTimeout(() => {
            element.removeAttribute('readonly');
          }, 500);
        });
      },
      togglePassword(e) {
        var togglePassword = $(e.target);
        var password = togglePassword.parent().find("[name='"+this.name+"']").first();
        // toggle the type attribute
        var type = password.attr("type") === "password" ? "text" : "password";
        password.attr("type", type);
        // toggle the eye / eye slash icon
        togglePassword.toggleClass("fa-eye");
        togglePassword.toggleClass("fa-eye-slash");
      },
    }
  }
</script>
